import React, { useState } from 'react';
import Modal from '../../../../../component/modal/Modal';
import Button from '../../../../../component/ui/Button';
import { getDate } from '../../../../../utils/dateUtils';
import { hasPermission } from '../../../../../utils/controller';
import CustomUpdateStatusModel from '../../../components/customUpdateStatusModel';
import { useNavigate } from 'react-router-dom';

export function InvoicePaymentReceivedAndCreditNoteDetailsModel({
  isOpen,
  setIsOpen,
  paymentReceives = [],
  creditNotes = [],
  onView,
  onDelete,
  user,
}) {
  const suburl = localStorage.getItem('suburl');
  const [deleteConfirm, setDeleteConfirm] = useState(null);

  const canDeletePR = hasPermission('sales.payments_received.delete', user?.role?.role_permissions);
  const canDeleteCN = hasPermission('sales.credit_notes.delete', user?.role?.role_permissions);

  const handleDeleteClick = (type, record) => {
    setDeleteConfirm({ type, record });
  };
  const navigate = useNavigate();

  const handleConfirmDelete = () => {
    if (deleteConfirm) {
      onDelete && onDelete(deleteConfirm.type, deleteConfirm.record);
      setDeleteConfirm(null);
    }
  };

  return (
    <>
      <Modal
        className="product_model"
        title={'Related Transactions Exist'}
        isOpen={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
        cancelButton={() => {
          setIsOpen(false);
        }}
      >
        <div
          className="d-flex align-items-start justify-content-start px-3 py-3 mb-3 rounded-1"
          style={{ backgroundColor: '#E6F5FF' }}
        >
          <span style={{ fontSize: '13px', color: '#1a1a2e' }}>
            This Sales Invoice has related Payment Received and/or Credit Note records. You must delete the applicable related transactions before editing this invoice. Please review the linked records below and delete them where permitted
          </span>
        </div>
        <div className="d-flex flex-column gap-2 py-1">

          {/* ── Payment Received ── */}
          {paymentReceives.length > 0 && (
            <div className="mb-1">
              <p className="fw-semibold mb-2" style={{ fontSize: '13px', color: '#1a1a2e' }}>
                Payment Received
              </p>
              <div className="d-flex flex-column gap-2">
                {paymentReceives.map((pr, index) => (
                  <div
                    key={pr.payment_receive?.id ?? index}
                    className="d-flex align-items-center justify-content-between rounded-2 px-3 py-2"
                    style={{ backgroundColor: '#F8F8FB', border: '1px solid #EBEBF5' }}
                  >
                    <div className="d-flex flex-column gap-1">
                      <span className="fw-semibold" style={{ fontSize: '14px', color: '#1a1a2e' }}>
                        {pr?.payment_receive?.payment_receive_number ?? `PR-${String(index + 1).padStart(3, '0')}`}
                      </span>
                      <div className="d-flex align-items-center gap-2">
                        <span className="text-secondary" style={{ fontSize: '12px' }}>
                          Rs. {Number(pr.invoice_payment_amount ?? 0).toFixed(2)}
                        </span>
                        <span className="text-secondary" style={{ fontSize: '12px' }}>|</span>
                        <span className="text-secondary" style={{ fontSize: '12px' }}>
                          {getDate(pr.payment_receive?.date)}
                        </span>
                      </div>
                    </div>
                    <div className="d-flex align-items-center gap-3">
                      <button
                        className="btn btn-link p-0 fw-medium text-decoration-none"
                        style={{ fontSize: '13px', color: '#3B58FF' }}
                        onClick={() => onView && onView('pr', pr)}
                      >
                        View
                      </button>
                      {canDeletePR && (
                        <button
                          className="btn btn-link p-0 fw-medium text-decoration-none text-danger"
                          style={{ fontSize: '13px' }}
                          onClick={() => handleDeleteClick('pr', pr)}
                        >
                          Delete
                        </button>
                      )}
                    </div>    
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* ── Credit Note ── */}
          {creditNotes.length > 0 && (
            <div className="mb-1">
              <p className="fw-semibold mb-2" style={{ fontSize: '13px', color: '#1a1a2e' }}>
                Credit Note
              </p>
              <div className="d-flex flex-column gap-2">
                {creditNotes.map((cn, index) => (
                  <div
                    key={cn.id ?? index}
                    className="d-flex align-items-center justify-content-between rounded-2 px-3 py-2"
                    style={{ backgroundColor: '#F8F8FB', border: '1px solid #EBEBF5' }}
                  >
                    <div className="d-flex flex-column gap-1">
                      <span className="fw-semibold" style={{ fontSize: '14px', color: '#1a1a2e' }}>
                        {cn?.credit_note?.credit_note_number ?? `CN-${String(index + 1).padStart(3, '0')}`}
                      </span>
                      <div className="d-flex align-items-center gap-2">
                        <span className="text-secondary" style={{ fontSize: '12px' }}>
                          Rs. {Number(cn.credit_note?.total_credit_amount ?? 0).toFixed(2)}
                        </span>
                        <span className="text-secondary" style={{ fontSize: '12px' }}>|</span>
                        <span className="text-secondary" style={{ fontSize: '12px' }}>
                          {getDate(cn.credit_note?.date)}
                        </span>
                      </div>
                    </div>
                    <div className="d-flex align-items-center gap-3">
                      <button
                        className="btn btn-link p-0 fw-medium text-decoration-none"
                        style={{ fontSize: '13px', color: '#3B58FF' }}
                        onClick={() => onView && onView('cn', cn)}
                      >
                        View
                      </button>
                      {cn?.credit_note?.status !== 'Closed' &&
						Number(cn?.credit_note?.total_paid_amount) === 0 && canDeleteCN && (
                        <button
                          className="btn btn-link p-0 fw-medium text-decoration-none text-danger"
                          style={{ fontSize: '13px' }}
                          onClick={() => handleDeleteClick('cn', cn)}
                        >
                          Delete
                        </button>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* ── Empty state ── */}
          {paymentReceives.length === 0 && creditNotes.length === 0 && (
            <p className="text-center text-secondary py-4 mb-0" style={{ fontSize: '13px' }}>
              No related transactions found.
            </p>
          )}

          <div className="d-flex justify-content-end mt-3">
            <Button
              type="button"
              button="Cancel"
              className="mt-0 px-4 btn-gray relative"
              onClick={() => setIsOpen(false)}
            />
          </div>

        </div>
      </Modal>

      {deleteConfirm && deleteConfirm.type === 'pr' && (
				<Modal
					className="deleteVendorsModal"
					title="Delete Payment Received"
					isOpen={!!deleteConfirm}
					onClose={() => {
						setDeleteConfirm(null);
					}}
					cancelButton={() => {
						setDeleteConfirm(null);
					}}
				>
					<p
						style={{
							textAlign: 'center',
							backgroundColor: '#E6F5FF',
							padding: '10px',
							borderRadius: '5px',
							fontWeight: '600',
							color: 'black',
						}}
					>
						{creditNotes.length > 0 ?  `You must delete the associated Credit Note ${creditNotes[0]?.credit_note?.credit_note_number} before deleting this Payment Received`:`Are you sure you want to delete this Payment Received?`}
					</p>

					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							gap: 10,
							justifyContent: 'end',
						}}
					>
						<Button
							type="button"
							className="mt-0 btn-gray add-pro"
							button="Cancel"
							onClick={() => {
								setDeleteConfirm(null);
							}}
						/>

						<Button
							type="button"
							button={creditNotes.length > 0 ? 'Go to ' + creditNotes[0]?.credit_note?.credit_note_number:'Confirm'}
							className="mt-0 px-4 btn-danger relative"
							
							onClick={() =>{
                if(creditNotes.length > 0){
                  navigate(
                    `/user/${suburl}/sales/credit-note-details/${creditNotes[0]?.credit_note_id}`,
                  )
                }else{
                  handleConfirmDelete()
                }
							}}
						/>
					</div>
				</Modal>
			)}

      {/* ── Delete Confirmation Modal ── */}
      {deleteConfirm && deleteConfirm.type === 'cn' && (
        <CustomUpdateStatusModel
          updateStatusModel={!!deleteConfirm}
          type="delete"
          setUpdateStatusModel={() => setDeleteConfirm(null)}
          title={ 'Delete Credit Note'}
          statusText={'Are you sure you want to delete this Credit Note?'}
          handleUpdateStatus={handleConfirmDelete}
        />
      )}
    </>
  );
}
